import axiosInstance from "../axios/instance";
import { setPublisherIdFromSearch } from "@revbox/helpers-fe";
import { getToken } from "../helpers/get-token";
import { iframeRoutes } from "../routes/PublicRoutes";

export default function verifyIframeToken() {
  const currentPath = window.location.pathname;
  const unavailablePaths = ['/adv', '/pub', '/signin', '/signup', '/change-password', '/forgot-password', ...iframeRoutes.map(route => route.path).join(',')];
  if (unavailablePaths.some(path => currentPath.includes(path))) {
    return;
  }

  const token = getToken();

  if (!token) {
    console.error("Case #44: Authorization token is missing.");
    return;
  }

  const verifyUrl = `${process.env.REACT_APP_HUB_URL}/api/auth/verify-customer-token/${token}`;

  axiosInstance
    .get(verifyUrl)
    .then((res) => {
      const ownerId = res?.data?.customer?.owner_id;

      if (!ownerId) {
        console.warn("Case #45: Owner ID not found in response.");
        return;
      }

      setPublisherIdFromSearch(ownerId);
    })
    .catch((err) => {
      console.error("Case #46: Error verifying token:", err);
    });
}
